import { render, staticRenderFns } from "./DriveUploadCard.vue?vue&type=template&id=13b8f136&scoped=true"
import script from "./DriveUploadCard.vue?vue&type=script&lang=ts"
export * from "./DriveUploadCard.vue?vue&type=script&lang=ts"
import style0 from "./DriveUploadCard.vue?vue&type=style&index=0&id=13b8f136&prod&scoped=true&lang=css"
import style1 from "./DriveUploadCard.vue?vue&type=style&index=1&id=13b8f136&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8f136",
  null
  
)

export default component.exports